import React, { useState } from "react";
import { Container } from "./styles";
import Modal from "react-modal";
import useClickedOutside from "../../../../../hooks/useClickedOutside";
import { CANVAS_OUTLINE_TYPES } from "../../../../../../../src/shared/canvasConstants";
import classNames from "classnames";

Modal.setAppElement("#root");

const Picker = ({
  subscription, //
  close,
  initialType,
  commitType,
}) => {
  const ref = useClickedOutside(close);

  const [type, setType] = useState(initialType);

  const customStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(55, 55, 55, 0.7)",
      zIndex: "100000001",
    },
    content: {
      top: "10%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      zIndex: "20000",
      width: "750px",
      transform: "translate(-50%, 0)",
      borderRadius: "15px",
      border: "0px",
      padding: "0px",
      background: "#f5f2e4",
      boxShadow: "var(--default-drop-shadow)",
    },
  };

  const typeItem = CANVAS_OUTLINE_TYPES.find((t) => t.value === type);

  return (
    <Modal
      isOpen={true}
      contentRef={(node) => (ref.current = node)}
      style={customStyles}
    >
      <Container className="picker">
        <div className="templates">
          <h2>Story Structure</h2>

          <ul>
            {CANVAS_OUTLINE_TYPES.map((t) => {
              return (
                <li
                  key={t.value}
                  className={classNames({ active: type === t.value })}
                  onClick={(e) => {
                    setType(t.value);
                  }}
                >
                  {t.label}
                </li>
              );
            })}
          </ul>
        </div>
        <div className="template">
          <h3>GREAT FOR:</h3>
          <p>{typeItem.great}</p>

          <h3>EXAMPLES:</h3>
          <div className="examples">
            {typeItem.examples?.map((example, i) => (
              <p key={`example_${i}`}>
                {example}{" "}
                <a
                  onClick={(e) => {
                    commitType({ type, concept: example });
                    close();
                  }}
                >
                  Try this &rarr;
                </a>
              </p>
            ))}
          </div>

          <button
            onClick={(e) => {
              commitType({ type });

              close();
            }}
          >
            Use {typeItem.label}
          </button>
        </div>
      </Container>
    </Modal>
  );
};

export default Picker;
